import {
  TEST_NAME_CHAR_BYTE_MAX_LENGTH,
  TEST_NAME_MAX_CHAR_LENGTH,
} from './constants';

const sanitizeTestNameInput = (testName = ''): string => {
  // using spread operator to treat emoji as individual char
  const characters = [...testName].slice(0, TEST_NAME_MAX_CHAR_LENGTH);
  return characters
    .filter((char) => new Blob([char]).size <= TEST_NAME_CHAR_BYTE_MAX_LENGTH)
    .join('');
};

export default {
  sanitizeTestNameInput,
};
